import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { ModalDialog, Button, SelectField, DateField } from 'vetrf-ui';
import { FormContainer } from 'components/FormContainer';
import { getCurrentDate } from 'utils/getCurrentDate';

type AddMotionModalProps<T, O extends { name: string; code: string }> = {
  onClose: () => void;
  onSubmit: (data: T) => Promise<void>;
  operationOptions: O[];
  operationFieldName?: string;
  dateFieldName?: string;
  lastStatusDate?: string;
  extraForm?: ReactNode;
};

export const AddMotionModal = <T, O extends { name: string; code: string }>({
  onClose,
  onSubmit,
  operationOptions,
  operationFieldName = 'operation',
  dateFieldName = 'statusDate',
  lastStatusDate,
  extraForm,
}: AddMotionModalProps<T, O>) => (
  <FormContainer onSubmit={(data) => onSubmit(data as T)}>
    <ModalDialog
      header="Добавить движение заявки"
      onClose={onClose}
      bodyClass={classNames('modal-body')}
      footer={
        <>
          <Button
            type="submit"
            color="success"
            iconColor="white"
            iconSize={100}
            size="sm"
            text="Добавить"
          />
          <Button
            color="grey"
            iconColor="white"
            iconSize={100}
            onClick={onClose}
            size="sm"
            text="Отменить"
          />
        </>
      }
    >
      <SelectField
        labelText="Функция"
        name={operationFieldName}
        labelKey="name"
        valueKey="code"
        options={operationOptions}
        required="Необходимо заполнить поле"
      />
      <DateField
        dateFormat="dd.MM.yyyy"
        defaultValue={getCurrentDate()}
        labelText="Дата изменения статуса"
        locale="ru"
        name={dateFieldName}
        required="Необходимо заполнить поле"
        validateDateFormat
        comparisonWithCurrentDate={{
          methodOfComparison: 'isSameOrBefore',
        }}
        comparisonWithAnotherDate={
          lastStatusDate && {
            value: lastStatusDate,
            methodOfComparison: 'isSameOrAfter',
          }
        }
      />
      {extraForm}
    </ModalDialog>
  </FormContainer>
);
